<template>
  <Modal
    extra-class="dea-modal--fiscal-code dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      Modifica il tuo codice fiscale
    </template>
    <template #content>
      <InputText v-model="fiscalCode" label="CODICE FISCALE" :message="message" :state="inputError"></InputText>
      <Buttons class="dea-button--large" @click="checkFiscalCode()">Salva modifiche</Buttons>
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import InputText from "@/components/elements/InputText";
import Modal from "@/components/patterns/Modal";

export default {
  name: "FiscalCodeModal",
  components: { Buttons, InputText, Modal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fiscalCode: "",
      titleLabel: "",
      showFcError: false,
    };
  },
  computed: {
    inputError() {
      let text = "";
      if (this.showFcError) {
        text = "error";
      }
      return text;
    },
    message() {
      let text = "";
      if (this.inputError) {
        text = "Codice fiscale errato";
      }
      return text;
    },
  },
  mounted() {
    if (this.user.cf) {
      this.fiscalCode = this.user.cf;
    }
    this.fiscalCode = this.user.cf ? this.user.cf : "";
    this.titleLabel = this.fiscalCode ? "Modifica" : "Aggiungi";
  },
  methods: {
    checkFiscalCode() {
      if (this.fiscalCode.length === 16) {
        const patt = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

        if (patt.test(this.fiscalCode)) {
          const lastNameCode = this.fiscalCode.substring(0, 3);
          const nameCode = this.fiscalCode.substring(3, 6);
          if (
            this.checkFiscalCodeValue(this.user.lastname, lastNameCode) &&
            this.checkFiscalCodeValue(this.user.firstname, nameCode, true)
          ) {
            this.showFcError = false;
            this.$emit("user-update", { cf: this.fiscalCode });
          } else {
            this.showFcError = true;
          }
        } else {
          this.showFcError = true;
        }
      } else {
        this.showFcError = true;
      }
    },
    checkFiscalCodeValue(namePart, fiscalCodePart, nameCheck) {
      const namePartUC = namePart.toUpperCase();
      const vowelsList = "AEIOU";
      const nameArray = namePartUC.split("");
      const consonants = nameArray.filter(char => vowelsList.indexOf(char) === -1);
      const vowels = nameArray.filter(char => vowelsList.indexOf(char) > -1);
      if (nameCheck && consonants.length > 3) {
        consonants.splice(1, 1);
      }
      const result =
        consonants
          .slice(0, 3)
          .concat(vowels.slice(0, 3 - consonants.slice(0, 3).length))
          .join("") === fiscalCodePart.toUpperCase();
      return result;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-modal--fiscal-code {
  .dea-input__icon--error {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
